import { useScrollReveal } from "../../../hooks/useScrollReveal";

const points = [
  {
    title: "Stability before scale.",
    desc: "We don't build on shaky foundations. Every system is designed to hold before it grows.",
    accent: "text-[#4ADE80]",
  },
  {
    title: "Systems over shortcuts.",
    desc: "Shortcuts compound into chaos. We build long-term infrastructure that eliminates firefighting.",
    accent: "text-white",
  },
  {
    title: "Intelligence without complexity.",
    desc: "Powerful AI shouldn't be complicated. We build intelligence that operates invisibly.",
    accent: "text-[#4ADE80]",
  },
  {
    title: "Built for the long term.",
    desc: "Every solution is architected to sustain performance months and years after deployment.",
    accent: "text-white",
  },
];

export default function ValueProposition() {
  const { ref: labelRef, visible: labelVisible } = useScrollReveal(0.1);

  return (
    <section className="w-full bg-[#050507] py-36 px-6 overflow-hidden">
      {/* Header label */}
      <div
        ref={labelRef as React.RefObject<HTMLDivElement>}
        className="max-w-7xl mx-auto text-center mb-24"
        style={{
          opacity: labelVisible ? 1 : 0,
          transform: labelVisible ? "translateY(0)" : "translateY(30px)",
          transition: "opacity 0.9s ease, transform 0.9s ease",
        }}
      >
        <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[#4ADE80]/80">
          Why GroundsWell AI
        </span>
      </div>

      {/* Large statement typography — Apple style */}
      <div className="max-w-7xl mx-auto space-y-0 divide-y divide-white/[0.06]">
        {points.map((point, i) => (
          <StatementRow key={point.title} point={point} idx={i} />
        ))}
      </div>
    </section>
  );
}

function StatementRow({
  point,
  idx,
}: {
  point: { title: string; desc: string; accent: string };
  idx: number;
}) {
  const { ref, visible } = useScrollReveal(0.15);

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className="py-14 md:py-16 grid grid-cols-1 md:grid-cols-2 gap-8 items-center group"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(30px)",
        transition: `opacity 0.9s ease ${idx * 0.1}s, transform 0.9s ease ${idx * 0.1}s`,
      }}
    >
      {/* Statement */}
      <h3
        className={`font-extrabold leading-[0.95] tracking-[-0.04em] ${point.accent} group-hover:opacity-90 transition-opacity`}
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "clamp(2.2rem, 4vw, 4rem)",
        }}
      >
        {point.title}
      </h3>

      {/* Description */}
      <p
        className="text-white/40 leading-relaxed"
        style={{ fontFamily: "'Inter', sans-serif", fontSize: "1.1rem" }}
      >
        {point.desc}
      </p>
    </div>
  );
}
